import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { login } from "@/lib/seoApi";
import { toast } from "sonner";

export default function SeoLogin() {
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      const dest = loc.state?.from?.pathname || "/seo-studio";
      nav(dest, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.errors?.[0]?.message || err.message || "Login failed";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <Card className="w-full max-w-md" data-testid="seo-login-card">
        <CardHeader>
          <CardTitle className="text-xl">SEO Studio · Sign in</CardTitle>
          <p className="text-sm text-neutral-500 pt-1">Use your Payload super-admin credentials.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required autoFocus
                     value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid="seo-login-email" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required
                     value={password} onChange={(e) => setPassword(e.target.value)}
                     data-testid="seo-login-password" />
            </div>
            <Button type="submit" className="w-full" disabled={busy}
                    data-testid="seo-login-submit">
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
